import {React} from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';
import InvoiceTableHeader from './Table-Header';
import InvoiceTableRow from './Table-Row';
import InvoiceTableFooter  from './TableFooter';

const styles = StyleSheet.create({
    tableContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginTop: 10,
        padding:0,
        borderColor: 'black',
        marginBottom: 20,
        borderLefttWidth: 1,
        borderLeftColor: 'black',

    },
});

const InvoiceItemsTable = ({ invoice }) => (
    <View style={styles.tableContainer} >
        <InvoiceTableHeader />
        <InvoiceTableRow invoice={invoice} />
        <InvoiceTableFooter invoice={invoice} />
    </View>
);

export default InvoiceItemsTable;